var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-list-view',{attrs:{"title":"","dataSource":_vm.HistoryNormalize,"headers":_vm.headers,"notShowSelect":"","isNested":"","header-hidden":"","hide-default-footer":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }